"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_TYPE_VIDYARD = exports.VIDEO_TYPE_EMBED = exports.VIDEO_TYPE_DISABLED = exports.videoHostValidationRule = void 0;
var videoHostValidationRule = {
  'youtube.com': 'https://www.youtube.com/embed/',
  'wistia.net': ['https://fast.wistia.net/embed/', 'https://fast.wistia.com/embed/'],
  'wistia.com': ['https://fast.wistia.net/embed/', 'https://fast.wistia.com/embed/'],
  'vidyard.com': 'https://play.vidyard.com/',
  'vimeo.com': 'https://player.vimeo.com/'
};
exports.videoHostValidationRule = videoHostValidationRule;
var VIDEO_TYPE_DISABLED = 'disabled';
exports.VIDEO_TYPE_DISABLED = VIDEO_TYPE_DISABLED;
var VIDEO_TYPE_EMBED = 'embed';
exports.VIDEO_TYPE_EMBED = VIDEO_TYPE_EMBED;
var VIDEO_TYPE_VIDYARD = 'vidyard';
exports.VIDEO_TYPE_VIDYARD = VIDEO_TYPE_VIDYARD;